import { Tooltip } from '@bfe/moly';
import { CloseIcon } from '@bfe/moly-icons';
import { useLocale } from '../../../store/i18nMessage';
import { Web3ConnectButton } from '../../Web3ConnectButton';
import { DisplayCurrentWallet } from './DisplayCurrentWallet';
import { useGuideTooltipShow } from './hook';
import './style.scss';

export type WalletStateProps = {
  className?: string;
};

export function WalletState(_props: WalletStateProps) {
  const { t } = useLocale();
  const { showGuideTooltip, closeTooltip } = useGuideTooltipShow();

  return (
    <Web3ConnectButton
      onConnectButton={(dom) => {
        const handleGuideConfirm = () => {
          // appStore.showWalletCreateModal = true;
          closeTooltip();
        };
        return (
          <div className="flex items-center">
            <Tooltip
              open={showGuideTooltip}
              overlayClassName="web3-connect-button-tooltip"
              zIndex={1e4}
              onOpenChange={(v) => {
                if (!v) {
                  closeTooltip();
                }
              }}
              title={
                <div className="tooltip-guide break-words">
                  <h4 className=" flex justify-between text-base font-medium">
                    {t('wallet_connect')}
                    <button
                      className="p-0 bg-transparent"
                      onClick={closeTooltip}
                      data-spm-even="SpotWeb3HomePageWalletHoverClick"
                      data-button_name="Close"
                    >
                      <CloseIcon className="cursor-pointer" />
                    </button>
                  </h4>
                  <p className="mt-1 text-sm text-bds-gray-t2">{t('create_wallet_tooltip_desc')}</p>
                  <div className="flex justify-end mt-3 mb-1">
                    <button
                      className=" text-bds-static-black rounded-md bg-bds-brand-700-normal px-4 py-[5px] text-xs"
                      data-spm-even="SpotWeb3HomePageWalletHoverClick"
                      data-button_name="Create"
                      onClick={handleGuideConfirm}
                    >
                      {t('btn_ok')}
                    </button>
                  </div>
                </div>
              }
            >
              {dom}
            </Tooltip>
          </div>
        );
      }}
    >
      <DisplayCurrentWallet />
    </Web3ConnectButton>
  );
}
